/* @flow */

// import { rem } from 'polished';

import { fadeDuration, pressDuration } from '@braindate/ui/lib/token/animation';
// import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { hoverSelector } from '@braindate/ui/lib/token/selector';
import { tablet } from '@braindate/ui/lib/token/mediaQuery';

import { maxTopbarContentHeight } from 'src/shared/app/nav/style/nav.style';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export const logoSize = {
  mobile: {
    width: 118,
    height: 42,
  },
  tablet: {
    width: 200,
    height: maxTopbarContentHeight,
  },
};

export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...logoSize.mobile,

    [tablet]: {
      ...logoSize.tablet,
    },

    textAlign: 'center',
    textDecoration: 'none',
    color: ({ theme }: ThemeFunction) => theme.textColor,

    transition: [
      ['opacity', fadeDuration],
      ['transform', pressDuration],
    ],

    [hoverSelector]: {
      opacity: 0.5,
    },
    '&:active': {
      transform: 'scale(0.90, 0.90)',
    },
  },
  platform: {
    display: 'inline',
  },
  braindateLogo: {
    height: '100%',
  },
  logo: {
    // To override a class defined in backpack
    maxHeight: `${maxTopbarContentHeight}px !important`,

    objectFit: 'contain',
  },
};
